var _rect, _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgNotificationOpen(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 40,
    height: 40,
    viewBox: "0 0 80 80",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 80,
    height: 80,
    rx: 40,
    fill: "#F0EFEC"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M58.6369 46.3002L27.0248 54.7706C26.2521 54.9776 25.4307 54.6519 25.0047 53.9754C24.5788 53.299 24.6609 52.4111 25.1802 51.8202C25.1977 51.8155 28.7645 47.2834 25.8139 36.2718C24.015 29.4881 28.052 22.4959 34.831 20.6795C41.6101 18.863 48.6022 22.9 50.4187 29.679C53.3692 40.6906 58.7194 42.8146 58.7815 42.8356C59.5139 43.1099 60.0113 43.8425 59.976 44.6237C59.9406 45.405 59.4097 46.0931 58.6369 46.3002ZM29.842 50.2511L53.9375 43.7947C51.6604 41.619 48.7886 37.6451 46.9062 30.6202C45.6074 25.773 40.6194 22.8931 35.7722 24.1919C30.925 25.4907 28.0451 30.4788 29.3439 35.326C31.2263 42.3509 30.7437 47.2236 29.842 50.2511Z",
    fill: "#8ACB23"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M45.1662 59.3212C44.2706 59.5612 43.2961 59.5776 42.3437 59.3246C41.431 59.0797 40.5848 58.5912 39.9164 57.9232C39.1988 57.212 39.2103 56.0607 39.904 55.3478C40.6152 54.6302 41.7665 54.6417 42.4794 55.3353C42.7081 55.5564 42.98 55.7283 43.2811 55.7982C44.2558 56.064 45.2471 55.4784 45.5177 54.5212C45.7836 53.5465 46.7796 52.9784 47.7543 53.2443C48.7291 53.5102 49.2971 54.5062 49.0313 55.4809C48.4995 57.4304 46.9927 58.8318 45.1662 59.3212Z",
    fill: "#8ACB23"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgNotificationOpen);
export default __webpack_public_path__ + "static/media/notificationOpen.0921c58a145411f5d7da01efb7a192d8.svg";
export { ForwardRef as ReactComponent };